import React, { useRef, useState, useEffect } from "react";
import { Container, Row, Col, Card, Form, Button, Table,} from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import Select from "react-select";
import { ApiUrl } from "../../../ApiUrl";
import { useNavigate } from "react-router-dom";
import "./AdmClassTimeTable.css";

const AdmAttendanceEntry = () => {
  const [classOptions, setClassOptions] = useState([]);
  const [sectionOptions, setSectionOptions] = useState([]);
  const [selectedClass, setSelectedClass] = useState(null);
  const [selectedMentor, setSelectedMentor] = useState(null);
  const [mentors, setMentors] = useState([]);
  const [periodOptions, setPeriodOptions] = useState([]);
  const [selectedPeriod, setSelectedPeriod] = useState(null);
  const [subjectOptions, setSubjectOptions] = useState([]);
  const [selectedSubject, setSelectedSubject] = useState(null);
  const [selectedSection, setSelectedSection] = useState(null);
  const [tableData, setTableData] = useState([]);
  const [showTable, setShowTable] = useState(false);
  const navigate = useNavigate();
  // const [totalLectures, setTotalLectures] = useState("");
  const [selectedDays, setSelectedDays] = useState([]);
  const formatPeriodLabel = (period) => {
    if (!period) return "";
    const name = period.period_name || "";
    const description = period.period_description || "";
    const time = period.period_time || "";
    const parts = [name];
    if (description && description !== name) {
      parts.push(description);
    }
    if (time) {
      parts.push(time);
    }
    return parts.filter(Boolean).join(" - ");
  };
  const handleClear = () => {
    // Clear dropdowns (Select)
    setSelectedClass(null);
    setSelectedSection(null);
    setSelectedSubject(null);
    setSelectedPeriod(null);
    setSelectedMentor(null);

    // Clear Days checkboxes
    setSelectedDays([]);

    // Clear Table Data
    setTableData([]);

    // Hide Table if needed
    setShowTable(false);
  };

  // Days array
  const allDays = [
    "MONDAY",
    "TUESDAY",
    "WEDNESDAY",
    "THURSDAY",
    "FRIDAY",
    "SATURDAY",
  ];
  // Fetch all classes
  useEffect(() => {
    fetch(`${ApiUrl.apiurl}Class/GetAllClass/`)
      .then((response) => response.json())
      .then((data) => {
        if (data && data.data) {
          const options = data.data.map((cls) => ({
            value: cls.id,
            label: cls.classname,
          }));
          setClassOptions([{ value: "", label: "Select Class" }, ...options]);
        }
      })
      .catch((error) => {
        console.error("Error fetching class data:", error);
      });
  }, []);

  // Fetch sections based on selected class  useEffect(() => {
  // Fetch sections based on selected class
  useEffect(() => {
    const fetchSectionData = async () => {
      if (!selectedClass) {
        setSectionOptions([]); // Clear sections if no class is selected
        return;
      }

      console.log("Fetching sections for classId:", selectedClass.value); // Debugging

      try {
        const response = await fetch(
          `${ApiUrl.apiurl}ClassSectionBind/GetAllSectionBindWithClass/${selectedClass.value}`
        );
        const data = await response.json();

        console.log("Section API response:", data); // Debugging

        if (data.message === "success") {
          const formattedSections = data.data.map((sectionItem) => ({
            value: sectionItem.id,
            label: sectionItem.sectionname,
          }));
          setSectionOptions(formattedSections);
        } else {
          console.error("Failed to fetch sections: ", data.message);
          setSectionOptions([]);
        }
      } catch (error) {
        console.error("Error fetching section data:", error);
        setSectionOptions([]);
      }
    };

    fetchSectionData();
  }, [selectedClass]);

  useEffect(() => {
    const fetchMentors = async () => {
      try {
        const orgId = localStorage.getItem("orgId");
        const branchId = localStorage.getItem("branchId");

        if (!orgId || !branchId) {
          console.error("Missing orgId or branchId in localStorage");
          return;
        }

        const response = await fetch(
          `${ApiUrl.apiurl}Teacher/GetEmployeeList/?orgId=${orgId}&branchId=${branchId}`
        );
        const data = await response.json();
        if (data && data.data) {
          // Mapping data to match React Select options format
          const formattedMentors = data.data.map((mentor) => ({
            value: mentor.id,
            label: mentor.employeeName,
          }));
          setMentors(formattedMentors);
        }
      } catch (error) {
        console.error("Error fetching mentors:", error);
      }
    };

    fetchMentors();
  }, []);

  useEffect(() => {
    const orgId = localStorage.getItem("orgId");
    const branchId = localStorage.getItem("branchId");

    if (orgId && branchId) {
      fetch(
        `${ApiUrl.apiurl}CLASS_PERIOD/GetCLASSPERIODLIST/${orgId}/${branchId}/`
      )
        .then((response) => response.json())
        .then((data) => {
          if (data.message === "success" && data.data) {
            const options = data.data.map((period) => ({
              value: period.id,
              label: formatPeriodLabel(period),
              period_name: period.period_name,
              period_description: period.period_description || "",
              period_time: period.period_time || "",
            }));
            setPeriodOptions([
              { value: "", label: "Select Period" },
              ...options,
            ]);
          }
        })
        .catch((error) => console.error("Error fetching period data:", error));
    }
  }, []);

  useEffect(() => {
    const fetchSubjects = async () => {
      const orgId = localStorage.getItem("orgId");
      const branchId = localStorage.getItem("branchId");
      const academicSessionId = localStorage.getItem("academicSessionId");
      const subjectGroupId = 1;

      if (!selectedClass) {
        setSubjectOptions([]);
        return;
      }

      const classId = selectedClass.value;

      const searchParams = new URLSearchParams({
        academic_year_id: academicSessionId,
        org_id: orgId,
        branch_id: branchId,
        subject_group_id: subjectGroupId,
        class_id: classId,
      });

      try {
        const response = await fetch(
          `${ApiUrl.apiurl}SUBJECTS/GetSubjectListBasedOnClassAndSection/?${searchParams}`
        );
        const data = await response.json();

        if (data.message === "success" && data.data) {
          const options = data.data.map((subject) => ({
            value: subject.id,
            label: subject.subjectcode,
          }));
          setSubjectOptions([
            { value: "", label: "Select Subject" },
            ...options,
          ]);
        } else {
          setSubjectOptions([{ value: "", label: "Select Subject" }]);
        }
      } catch (error) {
        console.error("Error fetching subject data:", error);
        setSubjectOptions([{ value: "", label: "Select Subject" }]);
      }
    };

    fetchSubjects();
  }, [selectedClass]); // removed selectedSection

  const handleSave = () => {
    const orgId = localStorage.getItem("orgId");
    const branchId = localStorage.getItem("branchId");
    const academicSessionId = localStorage.getItem("academicSessionId");
    const createdBy = sessionStorage.getItem("userId");

    if (
      !selectedMentor ||
      !selectedClass ||
      !selectedSection ||
      !selectedSubject ||
      !selectedPeriod ||
      selectedDays.length === 0
    ) {
      alert("Please fill all required fields.");
      return;
    }

    const requestBody = {
      academic_year_id: academicSessionId,
      org_id: orgId,
      branch_id: branchId,
      teacher_id: selectedMentor.value,
      class_id: selectedClass.value,
      section_id: selectedSection.value,
      subject_id: selectedSubject.value,
      class_period_id: selectedPeriod.value,
      days: selectedDays,
      created_by: createdBy,
    };

    console.log("Request Body:", requestBody);

    fetch(`${ApiUrl.apiurl}TIME_TABLE/TimeTableCreate/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestBody),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("Response:", data);
        if (data.message === "success" || data.success || data.status === "success") {
          alert("Time table created successfully");
        } else if (data.message) {
          alert(data.message);
        } else {
          alert("Something went wrong. Please try again.");
        }
      })
      .catch((error) => {
        console.error("Error saving Time Table Entry:", error);
        alert("Error saving Time Table Entry.");
      });
  };

  // Handle Day Selection
  const handleDayChange = (day) => {
    setSelectedDays((prevDays) =>
      prevDays.includes(day)
        ? prevDays.filter((d) => d !== day)
        : [...prevDays, day]
    );
  };

  const handleDisplay = async () => {
    const orgId = localStorage.getItem("orgId");
    const branchId = localStorage.getItem("branchId");
    const academicSessionId = localStorage.getItem("academicSessionId");

    const params = new URLSearchParams({
      academic_year_id: academicSessionId,
      org_id: orgId,
      branch_id: branchId,
    });

    if (selectedMentor) params.append("teacher_id", selectedMentor.value);
    if (selectedClass) params.append("class_id", selectedClass.value);
    if (selectedSection) params.append("section_id", selectedSection.value);
    if (selectedSubject) params.append("subject_id", selectedSubject.value);
    if (selectedPeriod) params.append("class_period_id", selectedPeriod.value);
    if (selectedDays.length > 0) params.append("days", selectedDays.join(","));

    try {
      const response = await fetch(
        `${
          ApiUrl.apiurl
        }TIME_TABLE/GetTimeTableEntryDifSearchBasisList/?${params.toString()}`
      );
      const data = await response.json();
      if (data && data.message === "success") {
        const enrichedTableData = (data.data || []).map((item) => {
          const matchedPeriod = periodOptions.find((period) => {
            if (!period?.value) return false;
            return (
              period.period_name === item.class_period ||
              period.label === item.class_period
            );
          });

          return {
            ...item,
            class_period_number:
              item.class_period_number ||
              matchedPeriod?.period_name?.replace(/[^0-9]/g, "") ||
              "",
            class_period_time:
              item.class_period_time || matchedPeriod?.period_time || "",
            class_period_description:
              item.class_period_description ||
              matchedPeriod?.period_description ||
              "",
          };
        });

        setTableData(enrichedTableData.length > 0 ? enrichedTableData : []);
        setShowTable(true);
      } else {
        setTableData([]);
        setShowTable(true);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setTableData([]);
      setShowTable(true);
    }
  };

  const handleDelete = async (id) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this entry?"
    );
    if (!confirmDelete) return;

    try {
      const response = await fetch(`${ApiUrl.apiurl}TIME_TABLE/delete/${id}`, {
        method: "DELETE",
      });
      const data = await response.json();
      if (data && data.message === "success") {
        setTableData((prevData) => prevData.filter((item) => item.id !== id));
      }
    } catch (error) {
      console.error("Error deleting entry:", error);
    }
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <div className="card p-0">
            <div className="card-body">
              <p
                style={{
                  marginBottom: "0px",
                  textAlign: "center",
                  fontSize: "20px",
                  fontWeight: "700",
                }}
              >
                CLASS TIMETABLE
              </p>

              <div className="row mb-3 mt-3 mx-0">
                <div className="col-12 d-flex flex-wrap gap-2">
                  <button
                    type="button"
                    className="btn btn-primary me-2"
                    style={{ width: "150px" }}
                    onClick={handleDisplay}
                  >
                    Display
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary me-2"
                    style={{ width: "150px" }}
                    onClick={handleSave}
                  >
                    Save
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary me-2"
                    style={{ width: "150px" }}
                    onClick={handleClear}
                  >
                    Clear
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger me-2"
                    style={{ width: "150px" }}
                    onClick={() => navigate("/admin/dashboard")}
                  >
                    Close
                  </button>
                </div>
              </div>

              <div className="row mt-3 mx-2">
                <div className="col-12 custom-section-box">
                  <Row>
                    {[
                      {
                        label: "Teacher",
                        id: "teacher",
                        component: (
                          <Select
                            id="mentor"
                            options={mentors}
                            className="detail"
                            value={selectedMentor}
                            onChange={setSelectedMentor}
                            placeholder="Select Mentor"
                            classNamePrefix="mentor-dropdown"
                          />
                        ),
                      },
                      {
                        label: "Class",
                        id: "class",
                        component: (
                          <Select
                            options={classOptions}
                            className="detail"
                            classNamePrefix="class-dropdown"
                            placeholder="Select Class"
                            value={selectedClass}
                            onChange={setSelectedClass} // Set selected class
                          />
                        ),
                      },
                      {
                        label: "Section",
                        id: "section",
                        component: (
                          <Select
                            options={sectionOptions}
                            className="detail"
                            classNamePrefix="section-dropdown"
                            placeholder="Select Section"
                            isDisabled={!selectedClass}
                            value={selectedSection} // Add this line to maintain state
                            onChange={setSelectedSection} // Add this line to update state
                          />
                        ),
                      },
                      {
                        label: "Subject",
                        id: "subject",
                        component: (
                          <Select
                            options={subjectOptions}
                            className="detail"
                            classNamePrefix="subject-dropdown"
                            placeholder="Select Subject"
                            isDisabled={!selectedClass} // Disable if no class is selected
                            // isDisabled={!selectedClass || !selectedSection}
                            value={selectedSubject}
                            onChange={setSelectedSubject}
                          />
                        ),
                      },

                      {
                        label: "Period",
                        id: "period",
                        component: (
                          <Select
                            options={periodOptions}
                            className="detail"
                            classNamePrefix="period-dropdown"
                            placeholder="Select Period"
                            value={selectedPeriod}
                            onChange={setSelectedPeriod}
                          />
                        ),
                      },
                    ].map((field, index) => (
                      <Col xs={12} md={4} key={index} className="mb-3">
                        <Form.Group controlId={field.id}>
                          <Form.Label>
                            {field.label} <span className="text-danger">*</span>
                          </Form.Label>
                          {field.component ? (
                            field.component
                          ) : (
                            <Form.Select>
                              {field.options.map((option, i) => (
                                <option key={i} value={i}>
                                  {option}
                                </option>
                              ))}
                            </Form.Select>
                          )}
                        </Form.Group>
                      </Col>
                    ))}
                    {/* <Col xs={12} md={8} className="mb-3">
                      <Form.Group>
                        <Form.Label>
                          Days <span className="text-danger">*</span>
                        </Form.Label>
                        <div className="d-flex flex-wrap gap-3">
                          {allDays.map((day, i) => (
                            <Form.Check
                              key={i}
                              type="checkbox"
                              label={day}
                              checked={selectedDays.includes(day)}
                              onChange={() => handleDayChange(day)}
                            />
                          ))}
                        </div>
                      </Form.Group>
                    </Col> */}
                    <Col xs={12} md={8} className="mb-3">
                      <Form.Group>
                        <Form.Label>
                          Days <span className="text-danger">*</span>
                        </Form.Label>
                        <div className="day-checkbox-grid">
                          {allDays.map((day, i) => (
                            <Form.Check
                              key={i}
                              type="checkbox"
                              label={day}
                              checked={selectedDays.includes(day)}
                              onChange={() => handleDayChange(day)}
                            />
                          ))}
                        </div>
                      </Form.Group>
                    </Col>

                    {/* <Col xs={12} md={4} className="mb-3 mt-2">
                      <Form.Group controlId="total-lectures">
                        <Form.Label>Total No. of Lectures</Form.Label>
                        <Form.Control
                          type="number"
                          placeholder="Enter total no. of lectures"
                          value={totalLectures}
                          onChange={(e) => setTotalLectures(e.target.value)}
                        />
                      </Form.Group>
                    </Col> */}
                  </Row>
                </div>
              </div>

              <div className="col-12">
                <Col>
                  <div className="table-responsive">
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th>Sr.No</th>
                          <th>Day</th>
                          <th>Class</th>
                          <th>Section</th>
                          <th>Subject</th>
                          <th>Period</th>
                          <th>Teacher</th>
                          <th>Delete</th>
                        </tr>
                      </thead>
                      <tbody>
                        {tableData.length > 0 ? (
                          tableData.map((item, index) => (
                            <tr key={item.id}>
                              <td>{index + 1}</td>
                      <td>{item.day}</td>
                      <td>{item.classname}</td>
                      <td>{item.sectionname}</td>
                      <td>{item.subjectname}</td>
                      <td>
                        <div>
                          {item.class_period_number
                            ? `Period ${item.class_period_number}`
                            : item.class_period}
                        </div>
                        {item.class_period_time ? (
                          <div className="text-muted small">
                            {item.class_period_time}
                          </div>
                        ) : (item.class_period_description &&
                          item.class_period_description !== item.class_period) ? (
                          <div className="text-muted small">
                            {item.class_period_description}
                          </div>
                        ) : null}
                      </td>
                      <td>{item.teacher_name}</td>
                              <td>
                                <a
                                  href="#"
                                  onClick={() => handleDelete(item.id)}
                                  className="text-danger"
                                >
                                  Delete
                                </a>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="8" className="text-center">
                              No data available
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </Col>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdmAttendanceEntry;
